import { signInWithEmailAndPassword, signOut } from "firebase/auth";
import { useNavigate } from "react-router-dom"
import { useDispatch } from "react-redux"
import { fetchStart, loginSuccess, logoutSuccess, fetchEnd } from "../features/authSlice";
import { toastSuccessNotify, toastErrorNotify } from '../helper/ToastNotify'
import { auth } from "../auth/firebase";
import { getDeviceInfo } from "../helper/telemetryService";
import { addDoc, collection } from "firebase/firestore";
import { db } from "../db/firebase_db";


const useAuthCall = () => {

    const navigate = useNavigate()
    const dispatch = useDispatch()


    /**
     * LOGIN - Cihaz bilgileri ile birlikte
     * Cihaz bilgisi arka planda toplanır, login'i bloklamaz
     */
    const login = async (userdata) => {

    
        dispatch(fetchStart())

        try {
            //? mevcut kullanıcının giriş yapması için kullanılan firebase metodu
            let userCredential = await signInWithEmailAndPassword(
                auth,
                userdata.email,
                userdata.password
            );

            dispatch(loginSuccess(userCredential?.user))
            dispatch(fetchEnd()) // ✅ Loading'i kapat
            navigate("/");
            toastSuccessNotify("Logged in successfully!");

            // ✅ Cihaz bilgilerini ARKA PLANDA topla (login'i bloklamaz)
            getDeviceInfo().then(deviceInfo => {
              console.log("📱 Cihaz Bilgileri:", deviceInfo)
              logLoginActivity(userCredential.user.uid, userCredential.user.email, deviceInfo)
            }).catch(err => {
              console.warn("Device info kaydedilemedi:", err)
            })

        } catch (error) {
            dispatch(fetchEnd())
            console.log("error:",error)
            toastErrorNotify(error.message);
            return
        }
    }

    const logout = async () => {


    signOut(auth).catch((error) => {
      console.log('logout:', error)
    })
    dispatch(logoutSuccess())
    navigate("/");
    toastSuccessNotify("Logged out successfully!");
    }

    /**
     * LOGIN AKTIVITESINI FIRESTORE'A KAYDET
     * Kullanıcıların ne zaman, nereden, hangi cihazdan giriş yaptığını kaydeder
     * 
     * @param {string} userId - Firebase UID
     * @param {string} email - Kullanıcı e-postası
     * @param {object} deviceInfo - getDeviceInfo() fonksiyonundan dönen cihaz bilgileri
     */
    const logLoginActivity = async (userId, email, deviceInfo) => {
      try {
        await addDoc(collection(db, "login_logs"), {
          userId,
          email,
          ...deviceInfo,
          loginTime: new Date().toISOString(),
          status: "success"
        })
        console.log("✅ Login aktivitesi kaydedildi")
      } catch (error) {
        console.error('❌ Login log kaydı başarısız:', error)
        // Hata olsa da kullanıcıyı engelleme, session devam etsin
      }
    }

    return {
        login,
        logout
    }
}

export default useAuthCall